import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Dialog, Transition } from "@headlessui/react";
import { setFormData, resetFormData } from "./OriginalDeedModalSlice";

const OriginalDeedModal = () => {
  const dispatch = useDispatch();
  const formData = useSelector((state) => state.originalDeed.formData);
  const { sroOptions } = useSelector((state) => state.property);
  const [show, setShow] = useState(true); // Control modal visibility

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(setFormData({ [name]: value }));
  };

  const handleDateChange = (date) => {
    dispatch(setFormData({ refRegdate: date }));
  };

  const handleClose = () => {
    setShow(false); // Hide the modal
  };

  const handleSaveDetails = (e) => {
    e.preventDefault();

    // Simulate saving logic - replace with actual implementation
    // For now, just log the form data
    console.log("Saved data:", formData);

    // You can reset the form data after saving
    //  dispatch(resetFormData());
    handleClose(); // Close the modal
  };

  return (
    <Transition show={show} as={React.Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 overflow-y-auto"
        onClose={handleClose}
      >
        <div className="flex items-center justify-center min-h-screen">
          <div className="bg-white shadow-lg overflow-hidden border-2 border-gray-200">
            <div className="px-4 py-5 sm:p-6">
              <h3 className="text-lg font-medium leading-6 text-gray-900 mb-4">
                Original Deed Details
              </h3>
              <form onSubmit={handleSaveDetails}>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* Sub-Registrar Office */}
                  <div>
                    <label
                      htmlFor="refSrocode"
                      className="block w-full relative"
                    >
                      Sub-Registrar Office:
                    </label>
                    <div className="block w-full relative">
                      <select
                        id="refSrocode"
                        name="refSrocode"
                        value={formData.refSrocode}
                        onChange={handleChange}
                        className="block w-full pl-2 pr-8 py-1.5 border border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        required
                      >
                        <option value="">Select an office</option>
                        {sroOptions.map((option) => (
                          <option key={option.sroCode} value={option.sroCode}>
                            {option.sroName}
                          </option>
                        ))}
                      </select>
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-400" />
                    </div>
                  </div>
                  {/* Registration Date */}
                  <div>
                    <label
                      htmlFor="refRegdate"
                      className="block w-full relative"
                    >
                      Registration Date:
                    </label>
                    <div className="block w-full relative">
                      <DatePicker
                        id="refRegdate"
                        selected={formData.refRegdate}
                        onChange={handleDateChange}
                        className="block w-full pl-2 pr-8 py-1.5 border border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        required
                      />
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-400" />
                    </div>
                  </div>
                </div>
                <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* Registration Number */}
                  <div>
                    <label htmlFor="refRegno" className="block w-full relative">
                      Registration Number:
                    </label>
                    <div className="block w-full relative">
                      <input
                        type="text"
                        id="refRegno"
                        name="refRegno"
                        value={formData.refRegno}
                        onChange={handleChange}
                        className="block w-full pl-2 pr-8 py-1.5 border border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        required
                      />
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-400" />
                    </div>
                  </div>
                  {/* Dafa 60 Details */}
                  <div>
                    <label
                      htmlFor="refDafa60"
                      className="block w-full relative"
                    >
                      Enter Dafa 60 Details:
                    </label>
                    <textarea
                      id="refDafa60"
                      name="refDafa60"
                      rows={5}
                      value={formData.refDafa60}
                      onChange={handleChange}
                      className="block w-full pl-2 pr-8 py-1.5 border border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      required
                    />
                  </div>
                </div>
                <div className="flex justify-between mt-4">
                  <button
                    type="submit"
                    className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    onClick={handleClose}
                    className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default OriginalDeedModal;
